// Activate toggles after the Ajax Updater loaded a page
jQuery('#main-content').on('ajax-updater:page-loaded', function() {
    jQuery('.bocss-toggle').setupToggle();
});

jQuery(document).ready(function() {
    jQuery('.bocss-toggle').setupToggle();
});

jQuery.fn.setupToggle = function() {
    // Have to return as an iterator or multiple toggles on the same page won't work
    return this.each(function() {
        let $toggle = jQuery(this);
        // buttons are invisible but still clickable for ease/accessiblity
        let $buttons = $toggle.children(".bocss-chart-toggle__radio");

        // Uses a data attribute to decide where the panes to be toggled live
        let $panels = jQuery('.'+$toggle.data('container')).children();

        // Handle for the toggle is generated on the fly
        let $toggleControl = jQuery('<div class="bocss-toggle__handle"></div>');
        $toggle.append($toggleControl);

        // Each of the possible states switched between
        // There may be a more dynamic way to do this but since there are only 3 I did it this way, if you see this feel
        // free to clean it up
        $buttons.click(function (event) {
            if (event.target === $buttons.eq(0)[0]) {
                // Showing Panel 1 only at full width
                $panels.eq(1).fadeOut(400, "swing", function () {
                    $panels.eq(0).fadeIn();
                    $panels.eq(0).removeClass("col-sm-6");
                    // end up with the first panel being full width
                    $panels.eq(0).addClass("col-sm-12");
                });
                // Show the toggle handle as blue at the left position to denote the left panel is the active in view
                $toggle.css("background-color", "var(--bocss-lightestgrey)");
                $toggleControl.css({'right': '3.75rem', 'background-color': 'var(--bocss-blue)'});
            }
            if (event.target === $buttons.eq(1)[0]) {
                // Comparison View: Showing both panels side by side at equal width
                $panels.eq(0).fadeIn();
                $panels.eq(1).fadeIn();

                // Making sure each panel ends up with col-sm-6 no matter the previous state of the panels
                $panels.eq(0).removeClass("col-sm-12");
                $panels.eq(0).addClass("col-sm-6");

                $panels.eq(1).removeClass("col-sm-12");
                $panels.eq(1).addClass("col-sm-6");

                // Show the toggle background as blue to denote that both panels are currently active
                $toggle.css("background-color", "var(--bocss-blue)");
                $toggleControl.css({'right': '1.875rem', 'background-color': 'var(--bocss-white)'});
            }
            if (event.target === $buttons.eq(2)[0]) {
                // Showing Panel 2 only at full width
                $panels.eq(0).fadeOut(400, "swing", function () {
                    $panels.eq(1).fadeIn();
                    $panels.eq(1).removeClass("col-sm-6");
                    $panels.eq(1).addClass("col-sm-12");
                });
                // Show the toggle handle as blue at the right position to denote the left panel is the active in view
                $toggle.css("background-color", "var(--bocss-lightestgrey)");
                $toggleControl.css({'right': '0rem', 'background-color': 'var(--bocss-blue)'});
            }
        });
    });
};
